import React from "react"
import HeaderHE from "./HeaderHE"
import HeaderEN from "./headerEN"
import { useLocation } from "@reach/router"
import ChangeLang from "./changeLang"

import "./layout.css"

const Layout = ({ children }) => {
  const location = useLocation()

  return (
    <>
      {/* IF IT IS A HEBREW PAGE, get Header in Hebrew, otherwise English */}
      {location.pathname.includes("/he") ? <HeaderHE /> : <HeaderEN />}
      {!location.pathname.includes("/projects") && <ChangeLang />}

      <main>{children}</main>
    </>
  )
}

export default Layout
